import { isAppWebview } from "./isAppWebview.js";

/**
 * Setzt das Attribut `is-webview`, wenn die Seite in einer App-Webview läuft, und entfernt es sonst.
 * Der Zustand ist damit über `hasAttribute("is-webview")`, den CSS-Selektor `[is-webview]` und die
 * Property `isWebview` von außen abfragbar.
 */
class AppWebviewDetector extends HTMLElement {
	static get tag() {
		return "app-webview-detector";
	}

	static {
		if (!customElements.get(AppWebviewDetector.tag)) {
			customElements.define(AppWebviewDetector.tag, AppWebviewDetector);
		}
	}

	get isWebview() {
		return this.hasAttribute("is-webview");
	}

	connectedCallback() {
		if (isAppWebview()) {
			this.setAttribute("is-webview", "");
		} else {
			this.removeAttribute("is-webview");
		}
	}
}
